<ISpinner [display]="loading()" main withTitle />
<div class="m-4" [class.disabled]="loading()" *transloco="let t">
  <div class="form-group row">
    <div class="col-sm-12">
      <ISelectMenu [(value)]="selectedUploadMode" fitTriggerWidth>
        <ISelectTrigger class="flex w-full">
          <ISelectValue>
            <div *iSelectValue="let value">{{ value | uploadModeLabel }}</div>
          </ISelectValue>
        </ISelectTrigger>
        <ISelectContent>
          @for (mode of uploadModes; track mode) {
            <ISelectOption [value]="mode">
              {{ mode | uploadModeLabel }}
            </ISelectOption>
          }
        </ISelectContent>
      </ISelectMenu>
    </div>
    @if (selectedUploadMode() === UploadMode.UPLOAD_COGS) {
      <div class="mt-2 w-full">
        <textarea
          type="text"
          #cogs
          class="coding-font"
          placeholder="asin1,cog1&#10;asin2,cog2&#10;COGS in {{
            modalData.currencySymbol
          }} must be entered as number only&#10;e.g. 'B07V1L8JL9,10.99' to set COGS for ASIN B07V1L8JL9 to {{
            10.99 | currency: modalData.currencySymbol
          }}"
          (input)="textareaContent.set(cogs.value)"
          (paste)="onPaste($event)"
        ></textarea>
        <div class="flex items-center justify-between">
          <div class="mt-1">
            <input
              #fileInput
              hidden
              type="file"
              accept="text/csv"
              (input)="onCsvUpload(fileInput.files)"
              (click)="fileInput.value = ''"
            />
            <button
              iButton
              variant="secondary"
              size="icon-sm"
              [iTooltip]="t('common.upload_csv')"
              (click)="fileInput.click()"
            >
              <IIcon name="upload" />
            </button>
          </div>
          <div class="danger">{{ fileUploadError }}</div>
          <button
            iButton
            size="md"
            [iTooltip]="t('upload-catalog-data-modal.uplaod_cost_of_goods')"
            [disabled]="isUploadButtonDisabled(textareaContent())"
            (click)="addCogs(cogs.value); cogs.value = ''; textareaContent.set('')"
          >
            {{ t("common.upload") }}
          </button>
        </div>
      </div>
    }
    @if (selectedUploadMode() === UploadMode.UPLOAD_CF) {
      <div class="mt-2 w-full">
        <textarea
          type="text"
          #cf
          class="coding-font"
          placeholder="asin1,field1,field2&#10;asin2,field1,field2"
          (input)="textareaContent.set(cf.value)"
          (paste)="onPaste($event)"
        ></textarea>
        <div class="flex items-center justify-between">
          <div class="mt-1">
            <input
              #fileInput
              hidden
              type="file"
              accept="text/csv"
              (input)="onCsvUpload(fileInput.files)"
              (click)="fileInput.value = ''"
            />
            <button
              iButton
              variant="secondary"
              size="icon-sm"
              [iTooltip]="t('common.upload_csv')"
              (click)="fileInput.click()"
            >
              <IIcon name="upload" />
            </button>
          </div>
          <div class="danger">{{ fileUploadError }}</div>
          <button
            iButton
            size="md"
            [iTooltip]="t('upload-catalog-data-modal.upload_custom_fields')"
            [disabled]="isUploadButtonDisabled(textareaContent())"
            (click)="addCFs(cf.value); cf.value = ''; textareaContent.set('')"
          >
            {{ t("common.upload") }}
          </button>
        </div>
      </div>
    }
    @if (selectedUploadMode() === UploadMode.UPLOAD_SEEDS) {
      <div class="mt-2">
        <div class="alert alert-warning">
          {{ t("upload-catalog-data-modal.warning_upload") }}
        </div>
        <textarea
          type="text"
          #seeds
          class="coding-font"
          placeholder="asin1,SEED,targetedProduct,asinToTarget1,asinToTarget2,…&#10;asin1,SEED,exact,keywordToTarget1,keywordToTarget2,…&#10;asin1,BLACKLIST,targetedProduct,asinToBlacklist1,asinToBlacklist2,asinToBlacklist3,…&#10;asin1,BLACKLIST,exact,keywordToBlacklist1,keywordToBlacklist2,…&#10;asin1,BLACKLIST,phrase,keywordToBlacklist1,keywordToBlacklist2,…&#10;asin2,SEED,targetedProduct,asinToTarget1,asinToTarget2,…&#10;…"
          (input)="textareaContent.set(seeds.value)"
          (paste)="onPaste($event)"
        ></textarea>
        <div class="flex items-center justify-between">
          <div class="mt-1">
            <input
              #fileInput
              hidden
              type="file"
              accept="text/csv"
              (input)="onCsvUpload(fileInput.files)"
              (click)="fileInput.value = ''"
            />
            <button
              iButton
              variant="secondary"
              size="icon-sm"
              [iTooltip]="t('common.upload_csv')"
              (click)="fileInput.click()"
            >
              <IIcon name="upload" />
            </button>
          </div>
          <div class="danger">{{ fileUploadError }}</div>
          <button
            iButton
            size="md"
            [iTooltip]="t('upload-catalog-data-modal.upload_keywords')"
            [disabled]="isUploadButtonDisabled(textareaContent())"
            (click)="addSeeds(seeds.value); seeds.value = ''; textareaContent.set('')"
          >
            {{ t("common.upload") }}
          </button>
        </div>
      </div>
    }
  </div>
</div>
